const YesNoNode = require('../YesNoNode');
const BattleCalc = require('../../BattleCalc');
const UseAbility = require('../UseAbility');
const TreeNode = require('../TreeNode');

const Q_ally_low_mana = function (actor, battleState) {
  const node = new YesNoNode(actor, battleState);

  node.sendMana = BattleCalc.getEquippedAbility(actor, 'send_mana');

  node.branches[node.NO] = new TreeNode(null, null);

  if (node.sendMana) {
    node.branches[node.YES] = new UseAbility(actor, 'send_mana');
  } else {
    node.branches[node.YES] = node.branches[node.NO];
  }

  node.getLowMPAlly = function () {
    const candidate_allies = BattleCalc.getAlliesOfUnit(
      this.actor,
      this.battleState.allUnits,
      false,
      false // don't send mana to summons
    ).filter((ally) => ally.max_mp - ally.mp >= node.sendMana.potency * 0.75);

    return candidate_allies.length
      ? candidate_allies[Math.floor(Math.random() * candidate_allies.length)]
      : null;
  };

  node.query = function () {
    if (this.sendMana) {
      var lowMPAlly = this.getLowMPAlly();
      if (lowMPAlly) {
        return this.branches[this.YES].query(lowMPAlly);
      } else {
        return this.branches[this.NO].query();
      }
    } else {
      return this.branches[this.NO].query();
    }
  };

  return node;
};
module.exports = Q_ally_low_mana;
